import styled from 'styled-components';
import NameAvatar from '../../UI/NameAvatar';
import { User } from '../../types';
import { useTranslation } from 'react-i18next';

interface NameProps {
  name: string;
  color: { main: string, light: string }
  onClick?: () => void;
  role?: string;
  company?: string;
  createdByUser?: { id: string; name: string } | null;
  currentUser?: User | null;
}

const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Wrap = styled.div`
  padding-left: 0.5rem;
`;

const FullName = styled.h5`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.43;
  color: #061c2e;
  margin-bottom: 0px;
  padding-left: 0.3em;
`;

const RoleItem = styled.p`
  font-size: 12px;
  line-height: 1.33;
  color: #627d95;
  margin: 0;
`;

const CreatedByWrapper = styled.div`
  margin-top: 0rem;
`;

const CreatedByText = styled.span`
  display: inline-block;
  font-size: 0.6rem;
  color: #627d95;
  font-weight: 400;
  background-color: #f0f2f5;
  padding: 0.1em 0.6em;
  border-radius: 1em;
  line-height: 1.4;
`;

const CandidateNameAvatar = ({
  name,
  color,
  role,
  company,
  onClick,
  createdByUser,
  currentUser
}: NameProps) => {
  const { t } = useTranslation();
  const showCreatedBy = currentUser && !currentUser.is_sourcer && createdByUser;

  return (
    <NameWrapper >
      <NameAvatar name={name} color={color} />
      <Wrap>
        <FullName onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'unset' }}>{name}</FullName>
        {showCreatedBy && (
          <CreatedByWrapper>
            <CreatedByText>
              {createdByUser?.id === currentUser?.id
                ? t('CREATED_BY_ME')
                : t('CREATED_BY_USER', { name: createdByUser?.name || '' })}
            </CreatedByText>
          </CreatedByWrapper>
        )}
        {role && company && (
          <RoleItem>
            {role} at {company}
          </RoleItem>
        )}
      </Wrap>
    </NameWrapper>
  );
};

export default CandidateNameAvatar;
